import logo from './logo.svg';
import './css/globals.css';
import MainRouter from './router/MainRouter';

function App() {
  return (
    <MainRouter/>
  );
}

export default App;
